import React from "react";
import {
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  VStack,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import PrimaryCard from "../common/cards/PrimaryCard";
import { FaEye } from "react-icons/fa";

const AvailableServicesCard = () => {
  const { t } = useTranslation();

  return (
    <PrimaryCard title={t("beneficiaryServices.availableServices.title")}>
      <VStack gap={4}>
        <InputGroup>
          <Input
            isDisabled={true}
            size={"sm"}
            value={t("beneficiaryServices.availableServices.towing")}
          />
          <InputRightElement height={"full"} marginX={2}>
            <Icon as={FaEye} boxSize={6} color={"gray.400"} />
          </InputRightElement>
        </InputGroup>
        <InputGroup>
          <Input
            isDisabled={true}
            size={"sm"}
            value={t("beneficiaryServices.availableServices.warranty")}
          />
          <InputRightElement height={"full"} marginX={2}>
            <Icon as={FaEye} boxSize={6} color={"gray.400"} />
          </InputRightElement>
        </InputGroup>
        <InputGroup>
          <Input
            isDisabled={true}
            size={"sm"}
            value={t("beneficiaryServices.availableServices.repair")}
          />
          <InputRightElement height={"full"} marginX={2}>
            <Icon as={FaEye} boxSize={6} color={"gray.400"} />
          </InputRightElement>
        </InputGroup>
      </VStack>
    </PrimaryCard>
  );
};

export default React.memo(AvailableServicesCard);
